import logger from "redux-logger";
import vars from "utils/vars";

export const middleware = vars.isDevelopment ? [logger] : [];

export default middleware;
